import { datadogRum } from "@datadog/browser-rum"
import { vuePlugin } from "@datadog/browser-rum-vue"

export default {
  install: () => {
    if (window.location.hostname !== "assessfirst.info") {
      return
    }

    datadogRum.init({
      applicationId: "ce6f3fa9-b431-4edc-8795-bdc28a987157",
      clientToken: "pub75af91a44ec0e6f44a9c5df666ebf0c7",
      site: "datadoghq.eu",
      service: "assessments",
      env: "development",
      sessionSampleRate: 100, // capture 100% of sessions
      sessionReplaySampleRate: 20, // capture 20% of sessions with replay
      trackResources: true, // Enable Resource tracking
      trackUserInteractions: true, // Enable Action tracking
      trackLongTasks: true, // Enable Long Tasks tracking

      plugins: [vuePlugin()],
    })
  },
}
